import { TemporaryTokenManager } from '@cobliteam/api-lib/src/account/cobler/TemporaryTokenManager';
import { AuthToken } from '@cobliteam/api-lib/src/account/session/AuthToken';
import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import type React from 'react';
import { useEffect } from 'react';

interface PublicRouterProviderProps {
  children: React.ReactNode;
}

const PublicRouterProvider = ({ children }: PublicRouterProviderProps) => {
  const session = useSessionStore((s) => s.session);
  const setSession = useSessionStore((s) => s.setSession);

  const temporaryToken = TemporaryTokenManager.getTemporaryToken();

  // setState/localStorage writes ficam fora do render — Strict Mode duplicaria a chamada e
  // subscribers de useSessionStore (PrivateRouterProvider) receberiam notificações duplicadas.
  useEffect(() => {
    if (!temporaryToken) return;
    localStorage.setItem(AuthToken.ACCESS_TOKEN, temporaryToken);
    const newSession = TemporaryTokenManager.buildSessionFromTemporaryToken(temporaryToken);
    if (session?.id !== newSession.id) setSession(newSession);
  }, [temporaryToken, session?.id, setSession]);

  // Também bloqueia quando `temporaryToken` está presente: o `useEffect` acima grava o
  // ACCESS_TOKEN e chama `setSession` só após o primeiro render, então sem esse braço a rota
  // pública pintaria por 1 frame antes do bloqueio/redirect assumir.
  const authToken = localStorage.getItem(AuthToken.ACCESS_TOKEN);
  if (authToken || temporaryToken) return null;

  return <>{children}</>;
};

export default PublicRouterProvider;
